import { Controller } from "@hotwired/stimulus"

// Reveals a dashboard section's collapsed overflow rows and hides the trigger.
// Rows are already rendered (just hidden), so this is a one-way client-side
// reveal — no server round-trip.
export default class extends Controller {
  static targets = ["extra", "button"]

  reveal() {
    this.extraTarget.classList.remove("hidden")
    this.buttonTarget.classList.add("hidden")
  }
}
